import { render } from "./appDownload.vue?vue&type=template&id=68b7fb17&scoped=true"
import script from "./appDownload.vue?vue&type=script&lang=js"
export * from "./appDownload.vue?vue&type=script&lang=js"

import "./appDownload.vue?vue&type=style&index=0&id=68b7fb17&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b7fb17"]])

export default __exports__